import { gql } from '@apollo/client';

/**
 * 标签动作: PREVIEW 只算数 / EXECUTE 执行 (受后端配置护栏)。已删别名不提供恢复, 由地址重新标准化时自动重建。
 *
 * <p>业务失败 (开关关 / 不在白名单 / 候选超限 / 锁冲突) 走返回值的 errorCode + message, 不是 GraphQL error。
 */
export const RUN_AOI_BIZ_TAG_ACTION = gql`
  mutation RunAoiBizTagAction($input: AoiBizTagActionInput!) {
    runAoiBizTagAction(input: $input) {
      aoiId
      tag
      action
      mode
      success
      candidateAddressCount
      truncated
      aliasCount
      affectedAliasCount
      dryRun
      taskId
      errorCode
      message
    }
  }
`;

export type AoiBizTagActionMode = 'PREVIEW' | 'EXECUTE';

export interface AoiBizTagActionInput {
    aoiId: number;
    zipcode: string;
    tag: string;
    action: string;
    mode: AoiBizTagActionMode;
}

export interface AoiBizTagActionResult {
    aoiId: number;
    tag: string;
    action: string;
    mode: AoiBizTagActionMode;
    success: boolean;
    candidateAddressCount: number;
    truncated: boolean;
    aliasCount: number;
    affectedAliasCount: number;
    dryRun: boolean;
    taskId: number | string | null;
    /** DISABLED / NOT_WHITELISTED / TRUNCATED / LOCKED / UNSUPPORTED / MAP_ERROR / EXEC_FAILED */
    errorCode: string | null;
    message: string | null;
}

export interface RunAoiBizTagActionResponse {
    runAoiBizTagAction: AoiBizTagActionResult;
}
